export default {
  namespaced: true,
  actions: {
    async login({ _dispatch }, { payload }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/clients/oauth/token',
          {
            username: payload.username,
            password: payload.password
          }
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async forgotPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/clients/forgot-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async resetPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/clients/reset-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async acceptInvitation({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/clients/invitations', payload)

        return true
      } catch (error) {
        throw error
      }
    }
  }
}
